@if (!isCvvValid) {
    <nz-result
        nzStatus="error"
        nzTitle="Invalid breakdown link"
        nzSubTitle="The link is invalid or has been changed. Please request a new link."
    ></nz-result>
}
@else if (callcentreLoadFailed) {
    <nz-result
        nzStatus="error"
        nzTitle="Unable to load call centre"
        nzSubTitle="Please try opening the breakdown link again."
    ></nz-result>
}
@else {
    <div class="fnb-header">
        <div class="header-title-row">
            <h1>Log a breakdown</h1>
            <button nz-button nzType="text" nzSize="large" class="breakdowns-link" (click)="onViewBreakdowns()">
                <nz-icon nzType="unordered-list" nzTheme="outline" />
                My breakdowns
            </button>
        </div>
        @if (callcentre) {
            <div class="callcentre-details">
                <div class="callcentre-name">
                    <span class="callcentre-label">Call centre</span>
                    <strong>{{ callcentre.clientName }}</strong>
                </div>
                @if (callcentre.clientCell) {
                    <a [href]="'tel:' + callcentre.clientCell">
                        <nz-icon nzType="phone" nzTheme="outline" /> {{ callcentre.clientCell }}
                    </a>
                }
            </div>
        }
    </div>

    <main class="mobile-container">
        <nz-spin [nzSpinning]="isLoadingCallcentre">
            @if (callcentre) {
                <section class="location-section">
                    <h2>Where is the breakdown?</h2>
                    <p>Select a point on the map, search for an address, or paste a Google Maps link.</p>

                    <div class="decode-location">
                        <input
                            nz-input
                            nzSize="large"
                            [(ngModel)]="locationLink"
                            placeholder="Paste a Google Maps link" />
                        <button
                            nz-button
                            nzType="default"
                            nzSize="large"
                            [nzLoading]="isDecodingLocation"
                            (click)="onClickDecodeLocationLink()">
                            Decode link
                        </button>
                    </div>

                    @if (incident.location && incident.location.description) {
                        <div class="selected-location">
                            <nz-icon nzType="environment" nzTheme="fill" />
                            {{ incident.location.description }}
                        </div>
                    }

                    <app-map-select
                        [mapMarkerLocation]="incident.location"
                        (locationSelected)="onLocationSelected($event)">
                    </app-map-select>

                    @if (saveFailed) {
                        <nz-alert
                            nzType="error"
                            nzShowIcon
                            nzMessage="Unable to log the breakdown. Please try again."
                            class="save-error">
                        </nz-alert>
                    }

                    <button
                        nz-button
                        nzType="primary"
                        nzSize="large"
                        nzBlock
                        class="log-breakdown-button"
                        [disabled]="!incident.location"
                        [nzLoading]="isSavingIncident"
                        (click)="onClickLogBreakdown()">
                        Log breakdown
                    </button>
                </section>
            }
        </nz-spin>
    </main>
}
